export type LoanTypes = "applications" | "current" | "repaid" | "archived"
export const LOAN_TYPE_LABELS: Record<LoanTypes, string> = {
  applications: "Quote",
  current: "Current",
  repaid: "Repaid",
  archived: "Archived",
}

export const PROPERTY_COUNT_CHOICES: Record<string, string> = {
  "0": "0",
  "1": "1",
  "2-4": "2-4",
  "5-9": "5-9",
  "10+": "10+",
}

export const CASH_RANGE_CHOICES: Record<string, string> = {
  "0-25": "$0k-$25k",
  "25-50": "$25k-$50k",
  "50-100": "$50k-$100k",
  "100+": "$100k+",
}

export const CREDIT_SCORE_CHOICES: Record<string, string> = {
  "below-640": "Below 640",
  "640-670": "640-670",
  "670-690": "670-690",
  "690+": "690+",
}

export const BORROWER_CHOICES: Record<string, string> = {
  self: "Self",
  entity: "Entity",
}

export const CONTRACT_STATUS_DISPLAY: Record<string, string> = {
  "under-contract": "Under contract",
  "this-week": "This week",
  "1-2-weeks": "1-2 weeks",
  "2-plus-weeks": "2+ weeks",
  unknown: "No contract",
  refinance: "Refinance",
}

export const LEGACY_PROPERTY_COUNT_TO_RANGE: Record<number, string> = {
  0: "0",
  1: "1-2",
  2: "2-4",
  3: "3-5",
  5: "3-5", // Deprecated
  6: "6+",
  10: "6+", // Deprecated
}

export const LEGACY_CREDIT_SCORE_TO_UPDATED: Record<string, string> = {
  "Below 620": "Below 640",
  "Below 640": "Below 640",
  "620-649": "Below 640",
  "640-669": "640-669",
  "650-679": "640-670",
  "670-689": "670-689",
  "680-699": "670-690",
  "690-749": "690-749",
  "700-719": "690+",
  "720-739": "690+",
  "Above 740": "690+",
  "Above 750": "750+",
  "750+": "750+",
}
